import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../utils/api';
import { useAuth } from '../../hooks/useAuth';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { toast } from 'sonner';

export const CandidateLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      console.log('Candidate login attempt:', email);
      const response = await api.post('/candidate/login', { email, password });
      console.log('Login response:', response.data);
      
      // Save auth data
      login(
        response.data.access_token,
        response.data.user_type,
        response.data.user_id,
        response.data.name
      );
      
      toast.success('Login successful');
      
      // Small delay to ensure state updates
      setTimeout(() => {
        navigate('/interview-portal/dashboard');
      }, 100);
      
    } catch (error) {
      console.error('Login error:', error);
      toast.error(error.response?.data?.detail || 'Login failed. Please check your credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div 
      className="min-h-screen flex items-center justify-center bg-cover bg-center"
      style={{
        backgroundImage: 'url(https://images.unsplash.com/photo-1761570942699-775c59ac7fac?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxjbGVhbiUyMHdoaXRlJTIwYXJjaGl0ZWN0dXJhbCUyMGJhY2tncm91bmR8ZW58MHx8fHwxNzc2NzQyMDgzfDA&ixlib=rb-4.1.0&q=85)'
      }}
    >
      <div className="w-full max-w-md p-8 bg-white/90 backdrop-blur-xl border border-slate-200 rounded-md">
        <h1 className="text-3xl font-light tracking-tight mb-2" style={{fontFamily: 'Outfit, sans-serif'}}>Interview Portal</h1>
        <p className="text-sm text-slate-500 mb-8">Access your assigned interviews</p>
        
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <Label htmlFor="email" data-testid="candidate-login-email-label">Email</Label>
            <Input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              data-testid="candidate-login-email-input"
              className="mt-2"
              placeholder="your.email@example.com"
            />
          </div>
          
          <div>
            <Label htmlFor="password" data-testid="candidate-login-password-label">Password</Label>
            <Input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              data-testid="candidate-login-password-input"
              className="mt-2"
              placeholder="Enter your password"
            />
          </div>
          
          <Button 
            type="submit" 
            className="w-full" 
            disabled={loading}
            data-testid="candidate-login-submit-button"
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </Button>
        </form>
        
        <div className="mt-6 text-center">
          <p className="text-xs text-slate-500">
            Contact your administrator if you don't have login credentials
          </p>
        </div>
      </div>
    </div>
  );
};
